import React from 'react';
import { AppSidebar } from './AppSidebar';
import { MobileNav } from './MobileNav';

interface AppLayoutProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  showSidebar?: boolean;
  selectedDatasetId?: string;
}

export const AppLayout: React.FC<AppLayoutProps> = ({
  children,
  showSidebar = true,
  selectedDatasetId,
}) => {

  return (
    <div className="h-screen-safe bg-white flex overflow-hidden">
      <MobileNav />
      <div className="flex-1 flex overflow-hidden pt-14 md:pt-0">
        {showSidebar && (
          <AppSidebar
            selectedDatasetId={selectedDatasetId}
          />
        )}

        <div className="flex-1 overflow-auto">
          {children}
        </div>
      </div>
    </div>
  );
};